import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Body from '../../fields/Body';
import Button from '../../fields/Button';
import Media from '../../fields/Media';

const ParagraphHero = props => {
    const { caption, link } = props;
    const classes = classNames('hero', { [`${props.classes}`]: props.classes });
    let media;
    try {
        media = props.r.media.r.image.file.cis.fluid.src;
    } catch {
        media = null;
    }
    const hasContent = caption || link;
    return (
        <section className={classes}>
            {media && <Media image={`<img src="${media}" alt="" />`} />}
            {hasContent && (
                <div className="hero__content">
                    {caption && <Body text={caption.value} />}
                    {link && <Button {...link} />}
                </div>
            )}
        </section>
    );
};

ParagraphHero.propTypes = {
    caption: PropTypes.shape({
        value: PropTypes.string,
    }),
    link: PropTypes.shape({
        title: PropTypes.string,
        uri: PropTypes.string,
    }),
    /** Entity References */
    r: PropTypes.shape({
        /** Media Component Properties. */
        media: PropTypes.shape({
            /** Entity References */
            r: PropTypes.shape({
                /** Image Tag */
                image: PropTypes.shape({
                    file: PropTypes.object,
                }),
            }),
        }),
    }),
    /** Extra classes */
    classes: PropTypes.string,
};

export default ParagraphHero;
